import Vue from 'global-vue'
import userRoleFilter from 'app/filters/userRole'
import userInitialsFilter from 'app/filters/userInitials'
import applicationFilter from 'app/filters/application'

export default class {
    run(){
        Vue.filter('userRole', userRoleFilter);
        Vue.filter('userInitials', userInitialsFilter);
        Vue.filter('application', applicationFilter);
    }
}